// import actions
import directorioAction from './actions/directorio'
import datoGeneralAction from './actions/dato_general'
import disenoHeaderAction from './actions/diseno_header'
import frmContactoAction from './actions/frm_contacto'
import frmLibroReclamacionAction from './actions/frm_libro_reclamacion'
import normativaTramiteAction from './actions/normativa_tramite'
import tramiteOrientacionAction from './actions/tramite_orientacion'
// import getters

// import mutations

// import states

const actions = { ...directorioAction, ...datoGeneralAction, ...disenoHeaderAction, ...frmContactoAction, ...frmLibroReclamacionAction, ...normativaTramiteAction, ...tramiteOrientacionAction }

const getters = { }

const mutations = { }

const state = { }

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
